export enum LandLayout {
  CORNER_PROPERTY = 'CORNER_PROPERTY',
  RECTANGULAR_FORMAT = 'RECTANGULAR_FORMAT',
  OTHER = 'OTHER',
}
